/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo, useState } from "react";
import objectPath from "object-path";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import LanguageSelectorDropdown from "./LanguageSelectorDropdown";
import "./styles.css";
import useAuth from "../../../../../hooks/useAuth";
import SainoLogo from "../../../../../images/logo/sales-simplify-logo.svg";


export function UserProfileDropdown() {
  //states
  const [name] = useState("Admin");
  const [email] = useState("admin@salessimplify.com");
  const [ProfilePic] = useState(SainoLogo);

  //selectors
  const { user } = useSelector((state) => state.auth);

  const { signOut } = useAuth();

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      light: objectPath.get(uiService.config, "extras.user.dropdown.style") === "light",
      viewLanguagesDisplay: objectPath.get(uiService.config, "extras.languages.display"),
    };
  }, [uiService]);

  return (
    <>
      <Dropdown drop="down" alignRight>
        <Dropdown.Toggle as={DropdownTopbarItemToggler} id="dropdown-toggle-user-profile">
          <div className={"btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"}>
            <span
              className="symbol symbol-35"
            // className="symbol symbol-35 symbol-light-success"
            >
              <span className={`symbol-label font-size-h5 font-weight-bold ${ProfilePic === undefined ? "" : ""}`} style={{ background: ProfilePic === undefined && "#121212" }}>
                {ProfilePic !== undefined && <img alt={name} src={ProfilePic} width="40" height="40" style={{ borderRadius: "0.475rem" }} />}
                {ProfilePic === undefined && <i className="bi bi-person-fill" style={{ color: "white" }}></i>}
              </span>
            </span>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ width: "290px" }} className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
          <>
            {/** ClassName should be 'dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
            {layoutProps.light && (
              <>
                <div className="d-flex align-items-center p-8 rounded-top mr-top-8">
                  <div className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0">
                    <img src={toAbsoluteUrl("/media/users/300_21.jpg")} alt="" />
                  </div>
                  <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">
                    {user.firstname} {user.lastname}
                  </div>
                  <span className="label label-light-success label-lg font-weight-bold label-inline">3 messages</span>
                </div>
                <div className="separator separator-solid"></div>
              </>
            )}

            {!layoutProps.light && (
              <div className="d-flex align-items-center flex-wrap bgi-size-cover bgi-no-repeat rounded-top" style={{ padding: "1rem 2rem" }}>
                <div className="symbol bg-white-o-15 mr-3">
                  <span className={`symbol-label text-success font-weight-bold font-size-h4 ${ProfilePic === undefined ? "" : ""}`} style={{ background: ProfilePic === undefined && "#121212" }}>
                    {ProfilePic !== undefined && <img alt={name} src={ProfilePic} width="50" height="50" style={{ borderRadius: "0.475rem" }} />}
                    {ProfilePic === undefined && <i className="bi bi-person-fill" style={{ color: "white" }}></i>}
                  </span>
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>{name}</Tooltip>}>
                    <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5" style={{ fontWeight: 600, fontSize: "1.15rem", width: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {name}
                    </div>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={<Tooltip>{email}</Tooltip>}>
                    <div style={{ color: "#a1a5b7", fontWeight: 500, fontSize: ".95rem", width: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{email}</div>
                  </OverlayTrigger>
                </div>
              </div>
            )}
          </>
          <div style={{ borderBottom: "1px solid #ebedf3" }}></div>

          <div className="navi navi-spacer-x-0 pt-5">
            <div style={{ display: "none" }}>
              <Link to="/settings/profile" className="navi-item px-8 cursor-pointer bg-hover pr-125 pl-125">
                <div className="navi-link profile-item-div">
                  <div className="navi-text">
                    <div className="font-weight-bold cursor-pointer profile-item-name">Profile Settings</div>
                  </div>
                </div>
              </Link>

              <Link to="/settings/profile/login-session" className="navi-item px-8 cursor-pointer bg-hover pr-125 pl-125">
                <div className="navi-link profile-item-div">
                  <div className="navi-text">
                    <div className="font-weight-bold cursor-pointer profile-item-name">Login Sessions</div>
                  </div>
                </div>
              </Link>
              <div className="navi-separator mt-3"></div>
              <>
                <Link to="/settings/account" className="navi-item px-8 cursor-pointer bg-hover pr-125 pl-125 navi navi-spacer-x-0 pt-5">
                  <div className="navi-link profile-item-div">
                    <div className="navi-text">
                      <div className="font-weight-bold cursor-pointer profile-item-name">Admin Settings</div>
                    </div>
                  </div>
                </Link>
                <Link to="/settings/account/team" className="navi-item px-8 cursor-pointer bg-hover pr-125 pl-125">
                  <div className="navi-link profile-item-div">
                    <div className="navi-text">
                      <div className="font-weight-bold cursor-pointer profile-item-name">Teams</div>
                    </div>
                  </div>
                </Link>
                <Link to="/settings/billing/subscription" className="navi-item px-8 cursor-pointer bg-hover pr-125 pl-125">
                  <div className="navi-link profile-item-div">
                    <div className="navi-text">
                      <div className="font-weight-bold cursor-pointer profile-item-name">Billing</div>
                    </div>
                  </div>
                </Link>
                <Link to="/settings/integrations" className="navi-item px-8 cursor-pointer bg-hover pr-125 pl-125">
                  <div className="navi-link profile-item-div">
                    <div className="navi-text">
                      <div className="font-weight-bold cursor-pointer profile-item-name">
                        Integrations
                        <span className="ml-3">
                          <div className="badge badge-light-primary">New</div>
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
                <Link to="/settings/account/security" className="navi-item px-8 cursor-pointer bg-hover pr-125 pl-125">
                  {/* // className={userProfile&& userProfile.data && userProfile.data.userType === "AGENT" ? "navi-item px-8 cursor-pointer bg-hover pr-125 pl-125 navi navi-spacer-x-0 pt-5" :"navi-item px-8 cursor-pointer bg-hover pr-125 pl-125"} > */}
                  <div className="navi-link profile-item-div">
                    <div className="navi-text">
                      <div className="font-weight-bold cursor-pointer profile-item-name">Security</div>
                    </div>
                  </div>
                </Link>{" "}
              </>

              {layoutProps.viewLanguagesDisplay && <LanguageSelectorDropdown />}
              <div className="navi-separator mt-3"></div>
            </div>

            <div className="navi-footer  px-8 py-5" style={{ paddingRight: "1.25rem", paddingLeft: "1.25rem" }}>
              <div
                // to="/auth/login"
                onClick={() => signOut()}
                className="btn btn-light-primary font-weight-bold"
              >
                Sign Out
              </div>
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}
